const data = [
  {
    brand: "Acer",
    model: "Iconia Talk S",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands": "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2",
    "3G_bands": "HSDPA 850 / 1900 / 2100",
    "4G_bands": "LTE band 1(2100)| 3(1800)| 7(2600)| 8(900)| 20(800)",
    network_speed: "HSPA 42.2/11.5 Mbps  LTE Cat4 150/50 Mbps",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2016 August",
    status: "Available. Released 2016  October",
    dimentions: "191.7 x 101 x 9.4 mm (7.55 x 3.98 x 0.37 in)",
    weight_g: "260",
    weight_oz: "9.17",
    SIM: "Dual SIM (Micro-SIM/Nano-SIM)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "7.0 inches (~69.8% screen-to-body ratio)",
    display_size: "720 x 1280 pixels (~210 ppi pixel density)",
    OS: "Android 6.0 (Marshmallow)",
    CPU: "Quad-core 1.3 GHz Cortex-A53",
    Chipset: "Mediatek MT8735",
    GPU: "Mali-T720MP2",
    memory_card: "microSD  up to 128 GB (dedicated slot)",
    internal_memory: "16/32 GB",
    RAM: "2 GB RAM",
    primary_camera: "13 MP| autofocus",
    secondary_camera: "2 MP| 720p",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 a/b/g/n| Wi-Fi Direct| hotspot",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS GLONASS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| proximity",
    battery: "Non-removable Li-Ion 3400 mAh battery (12.92 Wh)",
    colors: "Black",
    approx_price_EUR: "170",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-iconia-talk-s.jpg",
    id: 0,
  },
  {
    brand: "Acer",
    model: "Liquid Z6 Plus",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA",
    "4G_bands": "LTE",
    network_speed: "HSPA 42.2/5.76 Mbps  LTE Cat4 150/50 Mbps",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2016 August",
    status: "Available. Released 2016  December",
    dimentions: "153.8 x 75.6 x 8.5 mm (6.06 x 2.98 x 0.33 in)",
    weight_g: "169",
    weight_oz: "5.96",
    SIM: "Single SIM (Micro-SIM) or Dual SIM (Micro-SIM| dual stand-by)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "5.5 inches (~71.7% screen-to-body ratio)",
    display_size: "1080 x 1920 pixels (~401 ppi pixel density)",
    OS: "Android 6.0 (Marshmallow)",
    CPU: "Octa-core 1.3 GHz Cortex-A53",
    Chipset: "Mediatek MT6753",
    GPU: "Mali-T720MP3",
    memory_card: "microSD  up to 256 GB (uses SIM 2 slot)",
    internal_memory: "32 GB",
    RAM: "3 GB RAM",
    primary_camera: "13 MP| autofocus| LED flash",
    secondary_camera: "5 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 b/g/n| Wi-Fi Direct| hotspot",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Fingerprint (front-mounted)| accelerometer| proximity",
    battery: "Removable Li-Po 4080 mAh battery",
    colors: "Black| White",
    approx_price_EUR: "250",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-z6-plus.jpg",
    id: 1,
  },
  {
    brand: "Acer",
    model: "Liquid Z6",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA",
    "4G_bands": "LTE",
    network_speed: "HSPA  LTE",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2016 August",
    status: "Available. Released 2016  December",
    dimentions: "-",
    weight_g: "",
    weight_oz: "",
    SIM: "Single SIM (Micro-SIM) or Dual SIM (Micro-SIM| dual stand-by)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "5.0 inches",
    display_size: "720 x 1280 pixels (~294 ppi pixel density)",
    OS: "Android 6.0 (Marshmallow)",
    CPU: "Quad-core 1.25 GHz Cortex-A53",
    Chipset: "Mediatek MT6737",
    GPU: "Mali-T720MP2",
    memory_card: "microSD  up to 256 GB",
    internal_memory: "8 GB",
    RAM: "1 GB RAM",
    primary_camera: "8 MP| autofocus| LED flash",
    secondary_camera: "2 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Yes",
    bluetooth: "Yes",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| proximity",
    battery: "Removable Li-Ion 2000 mAh battery",
    colors: "Black| White",
    approx_price_EUR: "120",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-z6.jpg",
    id: 2,
  },
  {
    brand: "Acer",
    model: "Iconia Tab 10 A3-A40",
    network_technology: "No cellular connectivity",
    "2G_bands": "N/A",
    "3G_bands": "",
    "4G_bands": "",
    network_speed: "",
    GPRS: "No",
    EDGE: "No",
    announced: "2016 April",
    status: "Available. Released 2016  June",
    dimentions: "259 x 167 x 8.9 mm (10.20 x 6.57 x 0.35 in)",
    weight_g: "",
    weight_oz: "",
    SIM: "No",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "10.1 inches (~68.4% screen-to-body ratio)",
    display_size: "1920 x 1200 pixels (~224 ppi pixel density)",
    OS: "Android 6.0 (Marshmallow)",
    CPU: "Quad-core 1.3 GHz Cortex-A53",
    Chipset: "Mediatek MT8163A",
    GPU: "Mali-T720 MP2",
    memory_card: "microSD  up to 256 GB (dedicated slot)",
    internal_memory: "16/32/64 GB",
    RAM: "2 GB RAM",
    primary_camera: "5 MP",
    secondary_camera: "2 MP",
    loud_speaker: "Yes with stereo speakers (4 speakers)",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 a/b/g/n/ac| dual-band| hotspot",
    bluetooth: "Yes",
    GPS: "",
    NFC: "",
    radio: "No",
    USB: "microUSB 2.0",
    sensors: "Accelerometer",
    battery: "Non-removable Li-Ion battery",
    colors: "Black",
    approx_price_EUR: "230",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-iconia-tab-10-a3-a40.jpg",
    id: 3,
  },
  {
    brand: "Acer",
    model: "Liquid X2",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands": "GSM 850 / 900 / 1800 / 1900",
    "3G_bands": "HSDPA 900 / 1900 / 2100 - Europe| Taiwan",
    "4G_bands": "LTE 800 / 1800 / 2100 / 2600 - Europe",
    network_speed: "HSPA 42.2/5.76 Mbps  LTE Cat4 150/50 Mbps",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 April",
    status: "Available. Released 2016  February",
    dimentions: "153.3 x 78.8 x 8.5 mm (6.04 x 3.10 x 0.33 in)",
    weight_g: "166",
    weight_oz: "5.86",
    SIM: "Triple SIM (Micro-SIM)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "5.5 inches (~69.0% screen-to-body ratio)",
    display_size: "720 x 1280 pixels (~267 ppi pixel density)",
    OS: "Android 5.1 (Lollipop)",
    CPU: "Octa-core 1.3 GHz Cortex-A53",
    Chipset: "Mediatek MT6753",
    GPU: "Mali-T720MP4",
    memory_card: "microSD  up to 32 GB (dedicated slot)",
    internal_memory: "32 GB",
    RAM: "3 GB RAM",
    primary_camera: "13 MP| f/1.8| autofocus| LED flash|",
    secondary_camera: "13 MP| f/1.8| autofocus| LED flash",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 b/g/n| hotspot",
    bluetooth: "4.0| A2DP| LE",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| proximity| compass",
    battery: "Removable Li-Po 4020 mAh battery",
    colors: "Black| Gold",
    approx_price_EUR: "230",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-x2-1.jpg",
    id: 4,
  },
  {
    brand: "Acer",
    model: "Liquid Jade 2",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands": "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2",
    "3G_bands": "HSDPA 900 / 2100",
    "4G_bands": "LTE",
    network_speed: "HSPA 42.2/5.76 Mbps  LTE Cat4 150/50 Mbps",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2016 February",
    status: "Available",
    dimentions: "-",
    weight_g: "",
    weight_oz: "",
    SIM: "Dual SIM (Nano-SIM| dual stand-by)",
    display_type: "Super AMOLED capacitive touchscreen  16M colors",
    display_resolution: "5.5 inches",
    display_size: "1080 x 1920 pixels (~401 ppi pixel density)",
    OS: "Android 6.0 (Marshmallow)",
    CPU: "Hexa-core (4x1.4 GHz Cortex-A53 & 2x1.8 GHz Cortex-A57)",
    Chipset: "Qualcomm MSM8992 Snapdragon 808",
    GPU: "",
    memory_card: "microSD  up to 256 GB",
    internal_memory: "32 GB",
    RAM: "3 GB RAM",
    primary_camera: "21 MP| autofocus| dual-LED flash",
    secondary_camera: "8 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 a/b/g/n/ac| dual-band| Wi-Fi Direct| hotspot",
    bluetooth: "4.0| A2DP| LE",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| gyro| proximity| compass",
    battery: "",
    colors: "Black",
    approx_price_EUR: "80",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-jade-2.jpg",
    id: 5,
  },
  {
    brand: "Acer",
    model: "Liquid Zest Plus",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA",
    "4G_bands": "LTE",
    network_speed: "HSPA  LTE",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2016 April",
    status: "Available. Released 2016  July",
    dimentions: "154 x 77 x 10 mm (6.06 x 3.03 x 0.39 in)",
    weight_g: "",
    weight_oz: "",
    SIM: "Single SIM (Micro-SIM) or Dual SIM (Micro-SIM| dual stand-by)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "5.5 inches (~70.3% screen-to-body ratio)",
    display_size: "720 x 1280 pixels (~267 ppi pixel density)",
    OS: "Android 6.0 (Marshmallow)",
    CPU: "Quad-core 1.3 GHz Cortex-A53",
    Chipset: "Mediatek MT6735",
    GPU: "Mali-T720MP2",
    memory_card: "microSD (dedicated slot)",
    internal_memory: "16 GB",
    RAM: "2 GB RAM",
    primary_camera: "13 MP| phase detection/laser autofocus| LED flash",
    secondary_camera: "5 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Yes",
    bluetooth: "Yes",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| proximity| compass",
    battery: "Non-removable Li-Ion 5000 mAh battery",
    colors: "Blue| White",
    approx_price_EUR: "200",
    img_url:
      "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-zest-plus-z628.jpg",
    id: 6,
  },
  {
    brand: "Acer",
    model: "Liquid Zest",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA 850 / 900 / 1900 / 2100",
    "4G_bands": "LTE",
    network_speed: "HSPA  LTE Cat4 150/50 Mbps",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2016 February",
    status: "Available. Released 2016  April",
    dimentions: "145.7 x 71.2 x 8.4 mm (5.74 x 2.80 x 0.33 in)",
    weight_g: "125",
    weight_oz: "4.41",
    SIM: "Single SIM (Micro-SIM) or Dual SIM (Micro-SIM| dual stand-by)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "5.0 inches (~66.4% screen-to-body ratio)",
    display_size: "720 x 1280 pixels (~294 ppi pixel density)",
    OS: "Android 6.0 (Marshmallow)",
    CPU: "Quad-core 1.3 GHz - Z525",
    Chipset: "Mediatek MT6580 - Z525",
    GPU: "Mali-400MP2 - Z525",
    memory_card: "microSD  up to 32 GB (dedicated slot)",
    internal_memory: "8 GB",
    RAM: "1 GB RAM",
    primary_camera: "8 MP| f/2.0| autofocus| LED flash",
    secondary_camera: "5 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Yes",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| proximity| compass",
    battery: "Removable Li-Ion 2000 mAh battery",
    colors: "Black| White",
    approx_price_EUR: "110",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-zest.jpg",
    id: 7,
  },
  {
    brand: "Acer",
    model: "Predator 8",
    network_technology: "No cellular connectivity",
    "2G_bands": "N/A",
    "3G_bands": "",
    "4G_bands": "",
    network_speed: "",
    GPRS: "No",
    EDGE: "No",
    announced: "2015 September",
    status: "Available. Released 2015  November",
    dimentions: "217.9 x 127 x 8.6 mm (8.58 x 5.0 x 0.34 in)",
    weight_g: "353.8",
    weight_oz: "12.49",
    SIM: "No",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "8.0 inches (~67.1% screen-to-body ratio)",
    display_size: "1920 x 1200 pixels (~283 ppi pixel density)",
    OS: "Android 5.0 (Lollipop)",
    CPU: "Quad-core 1.6 GHz",
    Chipset: "Intel Atom x7-Z8700",
    GPU: "",
    memory_card: "microSD  up to 256 GB (dedicated slot)",
    internal_memory: "32/64 GB",
    RAM: "2 GB RAM",
    primary_camera: "5 MP",
    secondary_camera: "2 MP",
    loud_speaker: "Yes with stereo speakers (4 speakers)",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 a/b/g/n",
    bluetooth: "4.0| A2DP| LE",
    GPS: "",
    NFC: "",
    radio: "No",
    USB: "microUSB 2.0",
    sensors: "Yes",
    battery: "Non-removable Li-Po 4420 mAh battery",
    colors: "Black/Silver",
    approx_price_EUR: "350",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-predator-8.jpg",
    id: 8,
  },
  {
    brand: "Acer",
    model: "Liquid Jade Primo",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands": "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2",
    "3G_bands": "HSDPA 850 / 900 / 1900 / 2100 - Europe/ Taiwan",
    "4G_bands": "LTE 800 / 1800 / 2100 / 2600 - Europe",
    network_speed: "HSPA 42.2/5.76 Mbps  LTE-A (2CA) Cat6 300/50 Mbps",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 September",
    status: "Available. Released 2016  April",
    dimentions: "156.5 x 75.9 x 8.4 mm (6.16 x 2.99 x 0.33 in)",
    weight_g: "150",
    weight_oz: "5.29",
    SIM: "Dual SIM (Nano-SIM| dual stand-by)",
    display_type: "AMOLED capacitive touchscreen  16M colors",
    display_resolution: "5.5 inches (~70.2% screen-to-body ratio)",
    display_size: "1080 x 1920 pixels (~401 ppi pixel density)",
    OS: "Microsoft Windows 10",
    CPU: "Hexa-core (4x1.4 GHz Cortex-A53 & 2x1.8 GHz Cortex-A57)",
    Chipset: "Qualcomm MSM8992 Snapdragon 808",
    GPU: "Adreno 418",
    memory_card: "microSD  up to 256 GB (uses SIM 2 slot)",
    internal_memory: "32 GB",
    RAM: "3 GB RAM",
    primary_camera: "21 MP| f/2.2| autofocus| dual-LED flash|",
    secondary_camera: "8 MP| f/2.2| 1080p@30fps",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 a/b/g/n/ac| dual-band| WiFi Direct| hotspot",
    bluetooth: "4.0| A2DP| LE| EDR",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "3.1| Type-C 1.0 reversible connector",
    sensors: "Accelerometer| gyro| proximity| compass",
    battery: "Non-removable Li-Po 2870 mAh battery",
    colors: "Black",
    approx_price_EUR: "220",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-jade-primo-.jpg",
    id: 9,
  },
  {
    brand: "Acer",
    model: "Liquid Z330",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA",
    "4G_bands": "LTE",
    network_speed: "HSPA  LTE",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 September",
    status: "Available. Released 2015  October",
    dimentions: "136 x 66.5 x 9.6 mm (5.35 x 2.62 x 0.38 in)",
    weight_g: "142",
    weight_oz: "5.01",
    SIM: "Single SIM (Micro-SIM) or Dual SIM (Micro-SIM| dual stand-by)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "4.5 inches (~61.7% screen-to-body ratio)",
    display_size: "480 x 854 pixels (~218 ppi pixel density)",
    OS: "Android 5.1 (Lollipop)",
    CPU: "Quad-core 1.1 GHz Cortex-A7",
    Chipset: "Qualcomm MSM8909 Snapdragon 210",
    GPU: "Adreno 304",
    memory_card: "microSD (dedicated slot)",
    internal_memory: "8 GB",
    RAM: "1 GB RAM",
    primary_camera: "5 MP| autofocus| LED flash",
    secondary_camera: "5 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Yes",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| proximity",
    battery: "Removable Li-Ion 2000 mAh battery",
    colors: "Mystic Black| Pure White",
    approx_price_EUR: "110",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-z320-z330.jpg",
    id: 10,
  },
  {
    brand: "Acer",
    model: "Liquid Z320",
    network_technology: "GSM / HSPA",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA",
    "4G_bands": "",
    network_speed: "HSPA 42.2/5.76 Mbps",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 September",
    status: "Available. Released 2015  November",
    dimentions: "136 x 66.5 x 9.6 mm (5.35 x 2.62 x 0.38 in)",
    weight_g: "142",
    weight_oz: "5.01",
    SIM: "Single SIM (Micro-SIM) or Dual SIM (Micro-SIM| dual stand-by)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "4.5 inches (~61.7% screen-to-body ratio)",
    display_size: "480 x 854 pixels (~218 ppi pixel density)",
    OS: "Android 5.1 (Lollipop)",
    CPU: "Quad-core 1.0 GHz Cortex-A7",
    Chipset: "Qualcomm MSM8909 Snapdragon 210",
    GPU: "Adreno 304",
    memory_card: "microSD (dedicated slot)",
    internal_memory: "8 GB",
    RAM: "1 GB RAM",
    primary_camera: "5 MP| autofocus| LED flash",
    secondary_camera: "2 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Yes",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| proximity",
    battery: "Removable Li-Po 2000 mAh battery",
    colors: "Pure White",
    approx_price_EUR: "90",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-z320-z330.jpg",
    id: 11,
  },
  {
    brand: "Acer",
    model: "Liquid Z630S",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA 900 / 1900 / 2100",
    "4G_bands": "LTE",
    network_speed: "HSPA  LTE",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 September",
    status: "Available. Released 2015  September",
    dimentions: "156.3 x 77.5 x 8.9 mm (6.15 x 3.05 x 0.35 in)",
    weight_g: "165",
    weight_oz: "5.82",
    SIM: "Single SIM (Micro-SIM) or Dual SIM (Micro-SIM| dual stand-by)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "5.5 inches (~68.8% screen-to-body ratio)",
    display_size: "720 x 1280 pixels (~267 ppi pixel density)",
    OS: "Android 5.1 (Lollipop)",
    CPU: "Octa-core 1.3 GHz Cortex-A53",
    Chipset: "Mediatek MT6753",
    GPU: "Mali-T720MP3",
    memory_card: "microSD (dedicated slot)",
    internal_memory: "32 GB",
    RAM: "3 GB RAM",
    primary_camera: "8 MP| autofocus| LED flash",
    secondary_camera: "8 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 b/g/n| hotspot",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0| USB On-The-Go",
    sensors: "Accelerometer| proximity| compass",
    battery: "Removable Li-Po 4000 mAh battery (15.2 Wh)",
    colors: "Black| Gold",
    approx_price_EUR: "",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-z630.jpg",
    id: 12,
  },
  {
    brand: "Acer",
    model: "Liquid Z630",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA",
    "4G_bands": "LTE",
    network_speed: "HSPA  LTE",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 September",
    status: "Available. Released 2015  September",
    dimentions: "156.3 x 77.5 x 8.9 mm (6.15 x 3.05 x 0.35 in)",
    weight_g: "165",
    weight_oz: "5.82",
    SIM: "Single SIM (Micro-SIM) or Dual SIM (Micro-SIM| dual stand-by)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "5.5 inches (~68.8% screen-to-body ratio)",
    display_size: "720 x 1280 pixels (~267 ppi pixel density)",
    OS: "Android 5.1 (Lollipop)",
    CPU: "Quad-core 1.3 GHz Cortex-A53",
    Chipset: "Mediatek MT6735",
    GPU: "Mali-T720MP2",
    memory_card: "microSD (dedicated slot)",
    internal_memory: "8 GB",
    RAM: "1 GB RAM",
    primary_camera: "8 MP| autofocus| LED flash",
    secondary_camera: "8 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Yes",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0| USB On-The-Go",
    sensors: "Accelerometer| proximity| compass",
    battery: "Removable Li-Ion 4000 mAh battery",
    colors: "Black",
    approx_price_EUR: "200",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-z630.jpg",
    id: 13,
  },
  {
    brand: "Acer",
    model: "Liquid Z530S",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA",
    "4G_bands": "LTE",
    network_speed: "HSPA  LTE",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 September",
    status: "Available. Released 2015  November",
    dimentions: "144 x 70.3 x 8.9 mm (5.67 x 2.77 x 0.35 in)",
    weight_g: "145",
    weight_oz: "5.11",
    SIM: "Single SIM (Micro-SIM) or Dual SIM (Micro-SIM| dual stand-by)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "5.0 inches (~68.1% screen-to-body ratio)",
    display_size: "720 x 1280 pixels (~294 ppi pixel density)",
    OS: "Android 5.1 (Lollipop)",
    CPU: "Octa-core 1.3 GHz Cortex-A53",
    Chipset: "Mediatek MT6753",
    GPU: "Mali-T720MP3",
    memory_card: "microSD (dedicated slot)",
    internal_memory: "32 GB",
    RAM: "3 GB RAM",
    primary_camera: "8 MP| autofocus| LED flash",
    secondary_camera: "8 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Yes",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| proximity",
    battery: "Removable Li-Ion 2420 mAh battery",
    colors: "Black| White",
    approx_price_EUR: "",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-z530.jpg",
    id: 14,
  },
  {
    brand: "Acer",
    model: "Liquid Z530",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA",
    "4G_bands": "LTE",
    network_speed: "HSPA  LTE",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 September",
    status: "Available. Released 2015  October",
    dimentions: "144 x 70.3 x 8.9 mm (5.67 x 2.77 x 0.35 in)",
    weight_g: "145",
    weight_oz: "5.11",
    SIM: "Single SIM (Micro-SIM) or Dual SIM (Micro-SIM| dual stand-by)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "5.0 inches (~68.1% screen-to-body ratio)",
    display_size: "720 x 1280 pixels (~294 ppi pixel density)",
    OS: "Android 5.1 (Lollipop)",
    CPU: "Quad-core 1.3 GHz Cortex-A53",
    Chipset: "Mediatek MT6735",
    GPU: "Mali-T720MP2",
    memory_card: "microSD (dedicated slot)",
    internal_memory: "8 GB",
    RAM: "1 GB RAM",
    primary_camera: "8 MP| autofocus| LED flash",
    secondary_camera: "8 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Yes",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| proximity",
    battery: "Removable Li-Ion 2420 mAh battery",
    colors: "Black| White",
    approx_price_EUR: "150",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-z530.jpg",
    id: 15,
  },
  {
    brand: "Acer",
    model: "Liquid M330",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA",
    "4G_bands": "LTE",
    network_speed: "HSPA  LTE",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 September",
    status: "Available. Released 2015  November",
    dimentions: "136 x 66.5 x 9.6 mm (5.35 x 2.62 x 0.38 in)",
    weight_g: "142",
    weight_oz: "5.01",
    SIM: "Single SIM (Micro-SIM) or Dual SIM (Micro-SIM| dual stand-by)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "4.5 inches (~61.7% screen-to-body ratio)",
    display_size: "480 x 854 pixels (~218 ppi pixel density)",
    OS: "Microsoft Windows 10",
    CPU: "Quad-core 1.0 GHz Cortex-A7",
    Chipset: "Qualcomm MSM8909 Snapdragon 210",
    GPU: "Adreno 304",
    memory_card: "microSD (dedicated slot)",
    internal_memory: "8 GB",
    RAM: "1 GB RAM",
    primary_camera: "5 MP| autofocus| LED flash",
    secondary_camera: "5 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Yes",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| proximity",
    battery: "Removable Li-Ion 2000 mAh battery",
    colors: "Mystic Black| Pure White",
    approx_price_EUR: "",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-m320-m330.jpg",
    id: 16,
  },
  {
    brand: "Acer",
    model: "Liquid M320",
    network_technology: "GSM / HSPA",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA",
    "4G_bands": "",
    network_speed: "HSPA 42.2/5.76 Mbps",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 September",
    status: "Available. Released 2015  November",
    dimentions: "136 x 66.5 x 9.6 mm (5.35 x 2.62 x 0.38 in)",
    weight_g: "142",
    weight_oz: "5.01",
    SIM: "Single SIM (Micro-SIM) or Dual SIM (Micro-SIM| dual stand-by)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "4.5 inches (~61.7% screen-to-body ratio)",
    display_size: "480 x 854 pixels (~218 ppi pixel density)",
    OS: "Microsoft Windows 10",
    CPU: "Quad-core 1.1 GHz Cortex-A7",
    Chipset: "Qualcomm MSM8909 Snapdragon 210",
    GPU: "Adreno 304",
    memory_card: "microSD (dedicated slot)",
    internal_memory: "8 GB",
    RAM: "1 GB RAM",
    primary_camera: "5 MP| autofocus| LED flash",
    secondary_camera: "2 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Yes",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| proximity",
    battery: "Removable Li-Ion 2000 mAh battery",
    colors: "Mystic Black| Pure White",
    approx_price_EUR: "",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-m320-m330.jpg",
    id: 17,
  },
  {
    brand: "Acer",
    model: "Iconia Tab 10 A3-A30",
    network_technology: "No cellular connectivity",
    "2G_bands": "N/A",
    "3G_bands": "",
    "4G_bands": "",
    network_speed: "",
    GPRS: "No",
    EDGE: "No",
    announced: "2015 April",
    status: "Available. Released 2015  June",
    dimentions: "260 x 176 x 9.7 mm (10.24 x 6.93 x 0.38 in)",
    weight_g: "540",
    weight_oz: "1.19",
    SIM: "No",
    display_type: "LED-backlit IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "10.1 inches (~64.6% screen-to-body ratio)",
    display_size: "1920 x 1200 pixels (~224 ppi pixel density)",
    OS: "Android 5.0 (Lollipop)",
    CPU: "Quad-core 1.33 GHz",
    Chipset: "Intel Atom Z3735F",
    GPU: "",
    memory_card: "microSD  up to 256 GB (dedicated slot)",
    internal_memory: "16/32/64 GB",
    RAM: "2 GB RAM",
    primary_camera: "5 MP",
    secondary_camera: "2 MP",
    loud_speaker: "Yes with stereo speakers",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 a/b/g/n/ac| dual-band| hotspot",
    bluetooth: "4.0| A2DP",
    GPS: "A-GPS only",
    NFC: "Yes",
    radio: "No",
    USB: "microUSB 2.0",
    sensors: "Accelerometer",
    battery: "Non-removable Li-Ion 5910 mAh battery (22 Wh)",
    colors: "Various",
    approx_price_EUR: "250",
    img_url:
      "http://cdn2.gsmarena.com/vv/bigpic/acer-iconia-tab-10-a3-a30-new.png",
    id: 18,
  },
  {
    brand: "Acer",
    model: "Iconia One 8 B1-820",
    network_technology: "No cellular connectivity",
    "2G_bands": "N/A",
    "3G_bands": "",
    "4G_bands": "",
    network_speed: "",
    GPRS: "No",
    EDGE: "No",
    announced: "2015 April",
    status: "Available. Released 2015  May",
    dimentions: "213.9 x 127.7 x 9.5 mm (8.42 x 5.03 x 0.37 in)",
    weight_g: "355",
    weight_oz: "12.52",
    SIM: "No",
    display_type: "IPS LCD capacitive touchscreen",
    display_resolution: "8.0 inches (~67.9% screen-to-body ratio)",
    display_size: "800 x 1280 pixels (~189 ppi pixel density)",
    OS: "Android 5.0 (Lollipop)",
    CPU: "Quad-core 1.33 GHz",
    Chipset: "Intel Atom Z3735G",
    GPU: "",
    memory_card: "microSD  up to 32 GB (dedicated slot)",
    internal_memory: "16/32 GB",
    RAM: "1 GB RAM",
    primary_camera: "5 MP",
    secondary_camera: "VGA",
    loud_speaker: "Yes with stereo speakers",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 b/g/n",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS GLONASS",
    NFC: "",
    radio: "No",
    USB: "microUSB 2.0",
    sensors: "Accelerometer",
    battery: "Non-removable Li-Ion 4550 mAh battery (17.2 Wh)",
    colors: "Various",
    approx_price_EUR: "180",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-iconia-one-8-b1-820.jpg",
    id: 19,
  },
  {
    brand: "Acer",
    model: "Iconia Tab A3-A20",
    network_technology: "No cellular connectivity",
    "2G_bands": "N/A",
    "3G_bands": "",
    "4G_bands": "",
    network_speed: "",
    GPRS: "No",
    EDGE: "No",
    announced: "2014 October",
    status: "Available. Released 2014  October",
    dimentions: "256.5 x 170.2 x 10.2 mm (10.10 x 6.70 x 0.40 in)",
    weight_g: "508",
    weight_oz: "1.12",
    SIM: "No",
    display_type: "LED-backlit IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "10.1 inches (~67.8% screen-to-body ratio)",
    display_size: "1280 x 800 pixels (~149 ppi pixel density)",
    OS: "Android 4.4 (KitKat)",
    CPU: "Quad-core 1.3 GHz Cortex-A7",
    Chipset: "Mediatek MT8127",
    GPU: "Mali-450MP4",
    memory_card: "microSD  up to 256 GB (dedicated slot)",
    internal_memory: "16 GB",
    RAM: "1 GB RAM",
    primary_camera: "5 MP| autofocus",
    secondary_camera: "2 MP",
    loud_speaker: "Yes with stereo speakers",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 b/g/n| hotspot",
    bluetooth: "4.0| A2DP",
    GPS: "A-GPS only",
    NFC: "",
    radio: "No",
    USB: "microUSB 2.0",
    sensors: "Accelerometer",
    battery: "Non-removable Li-Po 5910 mAh battery (A3-A20-K1AY)",
    colors: "Black| White",
    approx_price_EUR: "190",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-a3-20.jpg",
    id: 20,
  },
  {
    brand: "Acer",
    model: "Iconia Tab A3-A20FHD",
    network_technology: "No cellular connectivity",
    "2G_bands": "N/A",
    "3G_bands": "",
    "4G_bands": "",
    network_speed: "",
    GPRS: "No",
    EDGE: "No",
    announced: "2014 October",
    status: "Available. Released 2014  October",
    dimentions: "256.5 x 170.2 x 10.2 mm (10.10 x 6.70 x 0.40 in)",
    weight_g: "508",
    weight_oz: "1.12",
    SIM: "No",
    display_type: "LED-backlit IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "10.1 inches (~67.8% screen-to-body ratio)",
    display_size: "1920 x 1200 pixels (~224 ppi pixel density)",
    OS: "Android 4.4 (KitKat)",
    CPU: "Quad-core 1.5 GHz Cortex-A7",
    Chipset: "Mediatek MT8127",
    GPU: "Mali-450MP4",
    memory_card: "microSD  up to 256 GB (dedicated slot)",
    internal_memory: "32 GB",
    RAM: "2 GB RAM",
    primary_camera: "5 MP| autofocus",
    secondary_camera: "2 MP",
    loud_speaker: "Yes with stereo speakers",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 b/g/n| hotspot",
    bluetooth: "4.0| A2DP",
    GPS: "A-GPS only",
    NFC: "",
    radio: "No",
    USB: "microUSB 2.0",
    sensors: "Accelerometer",
    battery: "Non-removable Li-Po 5910 mAh battery (A3-A20FHD-K8KX)",
    colors: "Black| White",
    approx_price_EUR: "230",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-a3-20.jpg",
    id: 21,
  },
  {
    brand: "Acer",
    model: "Liquid Jade Z",
    network_technology: "GSM / HSPA / LTE",
    "2G_bands": "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2",
    "3G_bands": "HSDPA 900 / 2100",
    "4G_bands": "LTE band 1(2100)| 3(1800)| 7(2600)| 20(800)",
    network_speed: "HSPA 21.1/5.76 Mbps  LTE Cat4 150/50 Mbps",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 March",
    status: "Available. Released 2015  April",
    dimentions: "143.5 x 69.8 x 8 mm (5.65 x 2.75 x 0.31 in)",
    weight_g: "110",
    weight_oz: "3.88",
    SIM: "Dual SIM (Nano-SIM| dual stand-by)",
    display_type: "IPS LCD capacitive touchscreen  16M colors",
    display_resolution: "5.0 inches (~68.8% screen-to-body ratio)",
    display_size: "720 x 1280 pixels (~294 ppi pixel density)",
    OS: "Android 5.0 (Lollipop)",
    CPU: "Quad-core 1.5 GHz Cortex-A53",
    Chipset: "Mediatek MT6732",
    GPU: "Mali-T760MP2",
    memory_card: "microSD  up to 32 GB (uses SIM 2 slot)",
    internal_memory: "8 GB",
    RAM: "1 GB RAM - Liquid Jade Z",
    primary_camera: "13 MP| f/1.8| autofocus| LED flash",
    secondary_camera: "5 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 b/g/n| hotspot",
    bluetooth: "4.0| A2DP| EDR",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| gyro| proximity| compass",
    battery: "Non-removable Li-Po 2300 mAh battery",
    colors: "Black| White",
    approx_price_EUR: "200",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-jade-z.jpg",
    id: 22,
  },
  {
    brand: "Acer",
    model: "Liquid Z520",
    network_technology: "GSM / HSPA",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA 900 / 2100",
    "4G_bands": "",
    network_speed: "HSPA",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 March",
    status: "Available. Released 2015  April",
    dimentions: "154 x 86 x 6.4 mm (6.06 x 3.39 x 0.25 in)",
    weight_g: "118",
    weight_oz: "4.16",
    SIM: "Single SIM (Micro-SIM) or Dual SIM (Micro-SIM| dual stand-by)",
    display_type: "TFT capacitive touchscreen",
    display_resolution: "5.0 inches (~57.1% screen-to-body ratio)",
    display_size: "480 x 854 pixels (~187 ppi pixel density)",
    OS: "Android 4.4.2 (KitKat)",
    CPU: "Quad-core 1.3 GHz Cortex-A7",
    Chipset: "Mediatek MT6582M",
    GPU: "Mali-400MP2",
    memory_card: "microSD  up to 32 GB (dedicated slot)",
    internal_memory: "8 GB",
    RAM: "1 GB RAM",
    primary_camera: "8 MP| autofocus| LED flash",
    secondary_camera: "2 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 b/g/n| hotspot",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| proximity",
    battery: "Removable Li-Po 2000 mAh battery",
    colors: "Black| White",
    approx_price_EUR: "130",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-z520.jpg",
    id: 23,
  },
  {
    brand: "Acer",
    model: "Liquid Z220",
    network_technology: "GSM / HSPA",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA 900 / 2100",
    "4G_bands": "",
    network_speed: "HSPA",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 March",
    status: "Available. Released 2015  April",
    dimentions: "125.3 x 64 x 9.6 mm (4.93 x 2.52 x 0.38 in)",
    weight_g: "120",
    weight_oz: "4.23",
    SIM: "Single SIM (Mini-SIM) or Dual SIM (Mini-SIM/Micro-SIM| dual stand-by)",
    display_type: "Capacitive touchscreen",
    display_resolution: "4.0 inches (~56.8% screen-to-body ratio)",
    display_size: "480 x 800 pixels (~233 ppi pixel density)",
    OS: "Android 5.0 (Lollipop)",
    CPU: "Dual-core 1.2 GHz Cortex-A7",
    Chipset: "Qualcomm Snapdragon 200",
    GPU: "Adreno 302",
    memory_card: "microSD  up to 32 GB (dedicated slot)",
    internal_memory: "8 GB",
    RAM: "1 GB RAM",
    primary_camera: "5 MP| autofocus| LED flash",
    secondary_camera: "2 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 b/g/n| hotspot",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer",
    battery: "Removable Li-Ion 1300 mAh battery",
    colors: "Black| White",
    approx_price_EUR: "90",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-z220.jpg",
    id: 24,
  },
  {
    brand: "Acer",
    model: "Liquid M220",
    network_technology: "GSM / HSPA",
    "2G_bands":
      "GSM 850 / 900 / 1800 / 1900 - SIM 1 & SIM 2 (dual-SIM model only)",
    "3G_bands": "HSDPA 900 / 2100",
    "4G_bands": "",
    network_speed: "HSPA 21.1/5.76 Mbps",
    GPRS: "Yes",
    EDGE: "Yes",
    announced: "2015 March",
    status: "Available. Released 2015  May",
    dimentions: "124.9 x 64 x 9.6 mm (4.92 x 2.52 x 0.38 in)",
    weight_g: "119",
    weight_oz: "4.2",
    SIM: "Single SIM (Mini-SIM) or Dual SIM (Mini-SIM/Micro-SIM| dual stand-by)",
    display_type: "TFT capacitive touchscreen",
    display_resolution: "4.0 inches (~57.0% screen-to-body ratio)",
    display_size: "480 x 800 pixels (~233 ppi pixel density)",
    OS: "Microsoft Windows Phone 8.1",
    CPU: "Dual-core 1.2 GHz Cortex-A7",
    Chipset: "Qualcomm MSM8210 Snapdragon 200",
    GPU: "Adreno 302",
    memory_card: "microSD  up to 32 GB (dedicated slot)",
    internal_memory: "4 GB",
    RAM: "512 MB RAM - Liquid M220",
    primary_camera: "5 MP| autofocus| LED flash",
    secondary_camera: "2 MP",
    loud_speaker: "Yes",
    audio_jack: "Yes",
    WLAN: "Wi-Fi 802.11 b/g/n| hotspot",
    bluetooth: "4.0| A2DP",
    GPS: "Yes with A-GPS",
    NFC: "",
    radio: "FM radio",
    USB: "microUSB 2.0",
    sensors: "Accelerometer| proximity",
    battery: "Removable Li-Ion 1300 mAh battery",
    colors: "Mystic Black| Pure White",
    approx_price_EUR: "80",
    img_url: "http://cdn2.gsmarena.com/vv/bigpic/acer-liquid-m220.jpg",
    id: 25,
  },
];

export default data;
